import { useLanguage } from '../../contexts/LanguageContext'
import './styles.css'

interface ModeToggleProps {
  isSpeedcubingMode: boolean
  onToggle: (mode: boolean) => void
}

export function ModeToggle({ isSpeedcubingMode, onToggle }: ModeToggleProps) {
  const { t } = useLanguage()

  const handleToggle = (mode: boolean) => {
    onToggle(mode)
  }

  return (
    <div className="mode-toggle-section">
      <div className="mode-toggle">
        <div className="mode-toggle-container">
          <button
            className={`mode-button ${!isSpeedcubingMode ? 'active' : ''}`}
            onClick={() => handleToggle(false)}
          >
            {t.modeToggle.cubeMode}
          </button>
          <button
            className={`mode-button ${isSpeedcubingMode ? 'active' : ''}`}
            onClick={() => handleToggle(true)}
          >
            {t.modeToggle.speedcubing}
          </button>
        </div>
      </div>

      {/* Mode change hint text */}
      <div className="mode-hint-text">
        {t.modeToggle.hint}
      </div>
    </div>
  )
}